import type { PromptDocument } from '../types'
import type { PlatformRenderer } from './index'

/**
 * Doubao (SeedDream) prefers concise, comma-separated descriptive tags without
 * MJ-style double-dash params. We mirror the MJ comma format for the body,
 * and translate only the subset that makes sense:
 *   - aspect ratio → inline 中文化提示 "画幅 16:9"
 *   - negatives   → trailing "不要: ..." 段
 */
export const doubaoRenderer: PlatformRenderer = {
  id: 'doubao',
  label: '豆包 (SeedDream)',
  render(doc) {
    const body = doc.sections
      .filter(s => s.enabled)
      .slice()
      .sort((a, b) => a.order - b.order)
      .flatMap(s => s.tags.map(t => t.raw.trim()).filter(Boolean))
      .join(', ')

    const tail: string[] = []
    if (doc.params.ar)
      tail.push(`画幅 ${doc.params.ar}`)
    const negatives = doc.params.no?.map(n => n.trim()).filter(Boolean) ?? []
    if (negatives.length)
      tail.push(`不要: ${negatives.join('、')}`)

    return [body, tail.join('，')].filter(Boolean).join('，')
  },
}
